module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "normal1-1"
  }, [_c('span', [_vm._v("“But if the while I think of thee, dear friend"), _c('br'), _vm._v("All losses are restored and sorrows end.”")])]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_c('span', [_vm._v("Shakespeare, Sonnet 30, line 13")])]), _vm._v(" "), _c('p', {
    staticClass: "center-b"
  }, [_c('span', [_vm._v("William E. Farrell, journalist,"), _c('br'), _vm._v("the "), _c('i', [_vm._v("New York Times")]), _c('br'), _vm._v("Joseph I. Grossman, sergeant, NYPD")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d6dd37b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0